import { ref } from 'vue';
import { defineStore } from 'pinia';
import { useAccountStore } from './account';
import type { FeatureFlagStatusModel } from '@/models';
import { getCurrentFeatureFlags } from '@/services/featureFlagService';
import type { FeatureFlagKeys } from '@/utils/featureFlags';

export const useFeatureFlagStore = defineStore('featureFlags', () => {
  const accountStore = useAccountStore();

  const hasLoadedFlags = ref(false);

  const featureFlags = ref<FeatureFlagStatusModel[]>([]);

  async function loadCurrentFeatures(): Promise<void> {
    if (!accountStore.hasCurrentAccount) {
      console.log(`${loadCurrentFeatures.name}: No current account selected`);
      return;
    }

    featureFlags.value = await getCurrentFeatureFlags();
    hasLoadedFlags.value = true;
  }

  function isFeatureEnabled(key: FeatureFlagKeys): boolean {
    const flag = featureFlags.value.find(x => x.key === key);
    return flag?.enabled || false;
  }

  return {
    featureFlags,
    hasLoadedFlags,
    loadCurrentFeatures,
    isFeatureEnabled,
  }
})
